import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

const UploadModalContext = createContext(null);

export function UploadModalProvider ({ children }) {
  // Handles Media type modal
  const [openMedia, setMediaOpen] = useState(false);

  const openMediaModal = useCallback(() => setMediaOpen(true), []);
  const closeMediaModal = useCallback(() => setMediaOpen(false), []);

  // Handles Tips modal
  const [openTips, setTipsOpen] = useState(false);

  const openTipsModal = useCallback(() => setTipsOpen(true), []);

  // Handles Delete modal
  const [itemToDelete, setItemToDelete] = useState(null);
  const [openDelete, setDeleteModalOpen] = useState(false);

  const openDeleteModal = useCallback((item) => {
    setItemToDelete(item);
    setDeleteModalOpen(true);
  }, []);

  const closeDeleteModal = useCallback(() => {
    setDeleteModalOpen(false);
    setItemToDelete(null);
  }, []);

  const value = useMemo(
    () => ({
      openMedia,
      setMediaOpen,
      openMediaModal,
      closeMediaModal,
      openTips,
      setTipsOpen,
      openTipsModal,
      openDelete,
      openDeleteModal,
      closeDeleteModal,
      itemToDelete
    }),
    [
      openMedia,
      openMediaModal,
      closeMediaModal,
      openTips,
      openTipsModal,
      itemToDelete,
      openDelete,
      openDeleteModal,
      closeDeleteModal
    ]
  );

  return (
    <UploadModalContext.Provider value={value}>
      {children}
    </UploadModalContext.Provider>
  );
}

UploadModalProvider.propTypes = {
  children: PropTypes.node
};

UploadModalProvider.defaultProps = {
  children: null
};

export function useUploadModal () {
  const ctx = useContext(UploadModalContext);
  if (!ctx) {
    throw new Error('useUploadModal must be used within <UploadModalProvider>');
  }
  return ctx;
}
